import React from "react";

import type { ConnectorProps } from "./redeem-credits.connect";

import { RedeemCredits } from "./redeem-credits";
import { RedeemCreditsLine } from "./redeem-credits-line";

type Props = ConnectorProps & {
  variant?: "line";
};

export const RedeemCreditsFactory = (props: Props) => {
  switch (props.variant) {
    case "line":
      return <RedeemCreditsLine {...props} />;
    default:
      return <RedeemCredits {...props} />;
  }
};
